function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarbonFootprintBreakdown = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _HorizontalBarChart = require("../HorizontalBarChart");
var _View = require("../View");
var _DropDownFilter = require("../DropDownFilter");
var _styles = require("../../styles");
var _ProgressChart = require("../ProgressChart");
var _Heading = require("../Heading");
var _IntroText = require("../IntroText");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["items", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var CarbonFootprintBreakdown = exports.CarbonFootprintBreakdown = (0, _react.memo)(function (_ref) {
  var _largestSubPart$label;
  var items = _ref.items,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useLang)();
  var _useStyles = (0, _styles2.useStyles)(),
    styles = _useStyles.styles;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedItem = _useState2[0],
    setSelectedItem = _useState2[1];
  var _useState3 = (0, _react.useState)(items),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    filterItems = _useState4[0],
    setFilterItems = _useState4[1];
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    spacing = _STYLES$useStyles.spacing;
  var handleFilter = function handleFilter(id) {
    if (id === _DropDownFilter.allId) {
      setSelectedItem(undefined);
      setFilterItems(items);
    } else {
      var _selectedItem = items.find(function (item) {
        return item.id === id;
      });
      if (_selectedItem) {
        setSelectedItem(_selectedItem);
        setFilterItems(_selectedItem.footprints || []);
      } else {
        setFilterItems([]);
      }
    }
  };
  var findLargestPart = function findLargestPart(items) {
    var _largestPart$footprin;
    var sortItems = function sortItems(a, b) {
      if (a.value > b.value) return -1;
      if (a.value < b.value) return 1;
      return 0;
    };
    var sortedItems = items.sort(sortItems);
    var largestPart = sortedItems[0];
    var largestSubPart = largestPart == null ? void 0 : (_largestPart$footprin = largestPart.footprints) == null ? void 0 : _largestPart$footprin.sort(sortItems)[0];
    return {
      largestPart: largestPart,
      largestSubPart: largestSubPart
    };
  };
  var _findLargestPart = findLargestPart(items),
    largestPart = _findLargestPart.largestPart,
    largestSubPart = _findLargestPart.largestSubPart;
  var largestSubPartValue = (((largestSubPart == null ? void 0 : largestSubPart.value) || 0) / ((largestPart == null ? void 0 : largestPart.value) || 1) * 100).toFixed(0);
  return (0, _jsxRuntime.jsxs)(_View.View, Object.assign({
    style: [styles.container, style]
  }, props, {
    children: [(0, _jsxRuntime.jsx)(_Heading.Heading, {
      level: 2,
      style: styles.heading,
      children: t('carbonFootprintBreakdown:heading')
    }), largestPart && (0, _jsxRuntime.jsx)(_IntroText.IntroText, {
      children: t('carbonFootprintBreakdown:largestPart', {
        largestPartLabel: largestPart.label.toLowerCase(),
        largestPartValue: (0, _ProgressChart.formatNumber)(largestPart.value),
        largestSubPartLabel: largestSubPart == null ? void 0 : (_largestSubPart$label = largestSubPart.label) == null ? void 0 : _largestSubPart$label.toLowerCase(),
        largestSubPartValue: largestSubPartValue
      })
    }), (0, _jsxRuntime.jsxs)(_View.View, {
      spacer: spacing.xxl,
      style: styles.filterContainer,
      children: [(0, _jsxRuntime.jsx)(_DropDownFilter.DropDownFilter, {
        items: items,
        showAllLabel: t('carbonFootprintBreakdown:filter.showAllLabel'),
        selectedItemPrefix: t('carbonFootprintBreakdown:filter.selectedItemPrefix'),
        optionPrefix: t('carbonFootprintBreakdown:filter.optionPrefix'),
        onClick: function onClick(id) {
          return handleFilter(id);
        },
        selectedItemId: selectedItem == null ? void 0 : selectedItem.id
      }), (0, _jsxRuntime.jsx)(_HorizontalBarChart.HorizontalBarChart, {
        items: filterItems || (selectedItem == null ? void 0 : selectedItem.footprints),
        barColor: COLORS.cherry,
        style: styles.chart
      })]
    })]
  }));
});